<label
  class="centered-row-container switcher-container"
  [class.opacity0p64]="disabled"
  [class.no-propagation]="noPropagation || disabled">
  <span *ngIf="leftText" [class.disabled]="value">{{leftText}}</span>
  <div class="switch">
    <input
      type="checkbox"
      [checked]="value"
      [disabled]="disabled"
      (change)="onCheckedChange($event)">
    <span
      data-qa="switch-slider"
      class="slider round {{value ? 'enabled' : 'disabled'}}"
      [class.standard]="!leftText">
    </span>
  </div>
  <span *ngIf="rightText" [class.disabled]="!value">{{rightText}}</span>
</label>
